<script lang="ts">
	import '$lib/style/reset.css';
	import '$lib/style/colors.css';
	import '$lib/style/global.css';
	import { page } from '$app/state';

	let { children } = $props();
</script>

<svelte:head>
	<title>{page.data.title || 'Regnskab'}</title>
</svelte:head>

{@render children()}

